import { userDetail } from '@/api/process'

let initPromise = null

export const ensureUserProfileInitialized = async () => {
  if (!initPromise) {
    initPromise = userDetail()
      .catch((error) => {
        console.error('初始化用户补充资料失败:', error)
        throw error
      })
      .finally(() => {
        initPromise = null
      })
  }
  return initPromise
}
